import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=4e8f63c2&"
import script from "./PopupLayout.vue?vue&type=script&lang=js&"
export * from "./PopupLayout.vue?vue&type=script&lang=js&"
import style0 from "./PopupLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VCard,VOverlay})
